import React, { useEffect } from "react";
import { Grid, Typography, Skeleton, Box } from '@mui/material';
import stringUtils from "../../../utils/stringUtils";

export default function POSHeader({ workOrder, loading }) {

    useEffect(() => {
        console.log("POSHeader - workOrder:", workOrder);
    }, [workOrder]);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                {loading ? (
                    <Skeleton variant="text" sx={{ width: '10ch' }} />
                ) : (
                    <Typography variant="subtitle1" fontWeight="bold">
                        Order - {workOrder ? workOrder.workOrderNumber : ''}
                    </Typography>
                )}
            </Grid>
            <Grid item xs={12}>
                {loading ? (
                    <Box>
                        <Skeleton variant="text" sx={{ width: '30ch' }} />
                        <Skeleton variant="text" sx={{ width: '30ch' }} />
                        <Skeleton variant="text" sx={{ width: '30ch' }} />
                    </Box>
                ) : (
                    <Box>
                        <Typography variant="body2" color="textSecondary">
                            Location: {workOrder?.location?.name || ''}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Time: {stringUtils.isoToLocalDateTime(workOrder?.createdAt, { date: true, time: true, seconds: true }) || ''}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Status: {workOrder?.status || ''}
                        </Typography>
                    </Box>
                )}
            </Grid>
        </Grid>
    );
}